Backbone = require 'backbone'
Backbone.$ = $
SharedAjaxErrorTemplate = require('../../ajax_error.html.mustache')

class SharedAjaxErrorView extends Backbone.View

  initialize : ->
    @I18nScope = 'modules.shared'
    @template = SharedAjaxErrorTemplate

  render : (hash) ->
    if hash?.container?
      @$container = hash.container
      @$container.html toHtml(@template, hash, @I18nScope)
      @bindEvents()
      @$container

  bindEvents : () ->
    $(".error_reload",@$container).on("click",()->
      window.location.reload()
    )

module.exports = SharedAjaxErrorView
